import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';
import {
  BusinessTypeInput,
  CustomerTypeInput,
} from '@diamond/sol-admin/features/shipto';

export function FiltersGroup() {
  const isNewCg3 = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_HIGHLIGHT_CG3_NEW,
    false
  );
  return (
    <>
      <CustomerTypeInput />
      {isNewCg3 && <BusinessTypeInput valueMode="codes" />}
    </>
  );
}
